import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { SessionService } from '../../services/session.service';

import {
  LoadSessionFailed,
  LoadSessionSuccess,
  SessionActionTypes
} from './actions';

@Injectable()
export class SessionEffects {
  public loadSession$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SessionActionTypes.Load),
      exhaustMap(() =>
        this.sessionService.getSession().pipe(
          map((session) => new LoadSessionSuccess(session)),
          catchError((error) =>
            of(new LoadSessionFailed(error && (error as Error).message))
          )
        )
      )
    )
  );

  public reLoadSession$: Observable<
    LoadSessionFailed | LoadSessionSuccess
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(SessionActionTypes.ReLoad),
      exhaustMap(() =>
        this.sessionService.reLoadSession().pipe(
          map((response) => {
            const authorizationHeader = response.headers.get('Authorization');
            if (authorizationHeader) {
              const token = this.extractToken(authorizationHeader);
              localStorage.setItem('token', token);
            }
            return new LoadSessionSuccess(response.body);
          }),
          catchError((error) =>
            of(new LoadSessionFailed(error && (error as Error).message))
          )
        )
      )
    )
  );

  private extractToken(authorizationHeader: string): string | null {
    const tokenPrefix = 'Bearer ';
    if (authorizationHeader.startsWith(tokenPrefix)) {
      return authorizationHeader.slice(tokenPrefix.length);
    }
    return null;
  }

  constructor(
    public sessionService: SessionService,
    private actions$: Actions
  ) {}
}
